import styles from '../Disco.module.css';

interface FeaturedImageProps {
  imageUrl: string;
  alt: string;
  targetUrl?: string;
  onAssetClick?: (targetUrl: string) => void;
  offerId?: string;
}

export function FeaturedImage({
  imageUrl,
  alt,
  targetUrl,
  onAssetClick,
  offerId,
}: FeaturedImageProps) {
  const image = (
    <img
      key={offerId}
      src={imageUrl}
      alt={alt}
      className={styles.featuredImage}
    />
  );

  if (targetUrl && onAssetClick) {
    return (
      <a
        key={offerId}
        href="#"
        onClick={(e) => {
          e.preventDefault();
          onAssetClick(targetUrl);
        }}
        className={styles.assetLink}
      >
        {image}
      </a>
    );
  }

  return image;
}
